import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "success-quiz-result-container"
};
const _hoisted_2 = {
  key: 0,
  class: "success-quiz-result-author"
};
const _hoisted_3 = {
  class: "author-alert"
};
const _hoisted_4 = {
  class: "author-alert-text"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 1,
  class: "success-quiz-result-reader"
};
const _hoisted_7 = {
  class: "success-quiz-result-title"
};
const _hoisted_8 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_dual_choice_toggle = _resolveComponent("dual-choice-toggle");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.isAuthor ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_icon, {
    icon: "information-outline",
    class: "author-alert-icon"
  }), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('view.speach.successQuiz.authorPreviewMsg')), 1)]), _createVNode(_component_dual_choice_toggle, {
    class: "completion-toggle",
    firstOption: _ctx.$t('view.speach.successQuiz.authorPreviewCompletionToggle.completed'),
    secondOption: _ctx.$t('view.speach.successQuiz.authorPreviewCompletionToggle.notCompleted'),
    firstOptionTooltip: _ctx.$t('view.speach.successQuiz.authorPreviewCompletionToggle.completedTooltip'),
    secondOptionTooltip: _ctx.$t('view.speach.successQuiz.authorPreviewCompletionToggle.notCompletedTooltip'),
    firstOptionIcon: "thumb-up-outline",
    secondOptionIcon: "thumb-down-outline",
    chooseFirstOptionByDefault: true,
    onChoiceUpdate: _ctx.updateCompletionMsg
  }, null, 8, ["firstOption", "secondOption", "firstOptionTooltip", "secondOptionTooltip", "onChoiceUpdate"]), _createElementVNode("p", {
    class: "completion-message",
    innerHTML: _ctx.completionMessage
  }, null, 8, _hoisted_5)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_icon, {
    icon: "check-decagram-outline",
    class: "success-quiz-result-icon"
  }), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('view.speach.successQuiz.score', {
    score: _ctx.quizResultPercentage
  })), 1), _createElementVNode("p", {
    class: "success-quiz-result-message",
    innerHTML: _ctx.completionMessage
  }, null, 8, _hoisted_8)]))]);
}